import React, { useContext, useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import { store, StateProvider } from '../Store';

export default function VisualizationsSPC({ textSourceCodeSPC }) {

  const { state, dispatch } = useContext(store);
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;

  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));

  useEffect(() => {
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  }, []);

  const downloadTxtFile = (content) => {
    const element = document.createElement("a");
    const file = new Blob([content], {
      type: "text/plain"
    });
    element.href = URL.createObjectURL(file);
    element.download = "Programa-Odisea.txt";
    document.body.appendChild(element);
    element.click();
  };

  const styleTheme = {
    'button': `${configData?.theme && configData.theme}-button`,
  };
  const submitText = 'Guardar Programa';

  const formatSPCText = (SPCText) => {
    let formatedText = SPCText;

    formatedText = formatedText.replaceAll('\n', ' ')
    formatedText = formatedText.replace(/ +(?= )/g,'')

    const keyWords = [
      'SELECTION ',
      'TABLE ',
      'TABLE ',
      'TABLELIST',
      'TABLELIST',
      'TITLE',
      'CROSSTABS ',
      ' FOR ',
      'OUTPUTFILE ',
      'FILTER ',
      'FREQ ',
      //'ZERO',
      'DECIMALS',
      'TABOP',
      'WEIGHT ',
      '//'
    ]
    
    keyWords.map((word) => {
      formatedText = formatedText.replaceAll(word.toLowerCase(), '<br>' + word.toLowerCase());
      formatedText = formatedText.replaceAll(word.toUpperCase(), '<br>' + word.toUpperCase());
    });

    formatedText = formatedText.replaceAll('\\"', '"')

    return (formatedText);

  };

  return (
    <>
    <div className="odisea-page-visualizations-spc-layout-flex">
      <Card className="odisea-page-visualizations-spc-card">
        <Card.Body><div dangerouslySetInnerHTML={{__html: formatSPCText(textSourceCodeSPC)}} /></Card.Body>
      </Card>
    </div>
    <div style={{margin: '20px', textAlign: 'center'}}>
    <Button type="submit" className={ "odisea-form-button-submit " + styleTheme.button } onClick={() => {downloadTxtFile(formatSPCText(textSourceCodeSPC).replaceAll('<br>', '\n'))}}>{submitText}</Button>
    </div>
    </>
  )
}
